module.exports = __webpack_public_path__ + "static/media/performance-card-header.2192d0d7.png";